import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, PrimaryButton, Tooltip, centsToUnits } from '@systemeio/ui';
import StripeWrapper from 'modules/profile/user-plan/components/price-plan-columns/components/stripe-wrapper';
import UpgradePlanConfirmationModal from 'modules/profile/user-plan/components/price-plan-columns/components/upgrade-plan-confirmation-modal';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UserPlanInterface, UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
import { twMerge } from 'tailwind-merge';
import { getPricePlanParams } from '../utils/get-price-plan-params';
export interface HeaderBlockProps {
  pricePlan: UserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  active?: boolean;
  isOneClickUpgradeAvailable?: boolean;
  paymentMethod?: UseUserPlanInterface['customer']['paymentMethod'];
  isPlanUpgradeAvailable?: boolean;
}
const HeaderBlock = t0 => {
  const $ = _c(42);
  const {
    pricePlan,
    billingPeriod,
    active: t1,
    isOneClickUpgradeAvailable: t2,
    paymentMethod,
    isPlanUpgradeAvailable
  } = t0;
  const active = t1 === undefined ? false : t1;
  const isOneClickUpgradeAvailable = t2 === undefined ? false : t2;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== active || $[1] !== billingPeriod || $[2] !== isOneClickUpgradeAvailable || $[3] !== isPlanUpgradeAvailable || $[4] !== paymentMethod || $[5] !== pricePlan || $[6] !== t || $[7] !== user?.dashboardLocale) {
    const {
      cost,
      paymentPageUrl,
      periodLabel
    } = getPricePlanParams(pricePlan);
    const isPriceInvisible = !pricePlan.price;
    let costTitleShort = "";
    let costTitle = "";
    if (pricePlan.price) {
      costTitleShort = currencyFormat(centsToUnits(cost), pricePlan.price.currency || CurrencyEnum.EURO, user?.dashboardLocale, true);
      costTitle = currencyFormat(centsToUnits(cost), pricePlan.price.currency || CurrencyEnum.EURO, user?.dashboardLocale);
    }
    t7 = `headCell-${pricePlan.id}`;
    const t9 = active ? "text-brand-primary" : "text-text-primary";
    if ($[14] !== t9) {
      t8 = twMerge("font-inter text-start h-[150px]  font-bold", t9, "mb-6 min-w-[100px]");
      $[14] = t9;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    const t10 = !active && "border-fill-primary rounded-lg border-solid";
    if ($[16] !== t10) {
      t3 = twMerge("flex flex-col gap-2 border border-transparent px-2 py-2 lg:px-4", t10);
      $[16] = t10;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    let t11;
    if ($[18] !== active) {
      t11 = active ? {
        "data-test": "current-plan"
      } : {};
      $[18] = active;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    let t12;
    if ($[20] !== pricePlan.title || $[21] !== t11) {
      t12 = <span className="truncate" {...t11}>{pricePlan.title}</span>;
      $[20] = pricePlan.title;
      $[21] = t11;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    if ($[23] !== pricePlan.title || $[24] !== t12) {
      t4 = <div className="truncate text-xl font-medium"><Tooltip mode="overflow" label={pricePlan.title}>{t12}</Tooltip></div>;
      $[23] = pricePlan.title;
      $[24] = t12;
      $[25] = t4;
    } else {
      t4 = $[25];
    }
    const t13 = isPriceInvisible && "invisible";
    let t14;
    if ($[26] !== t13) {
      t14 = twMerge("truncate", t13);
      $[26] = t13;
      $[27] = t14;
    } else {
      t14 = $[27];
    }
    t5 = <div className={t14}><span className="text-xl lg:text-3xl">{costTitleShort}</span><span className="text-base font-normal">/{t(periodLabel).toLowerCase()}</span></div>;
    t6 = active ? <PrimaryButton as={LinkWithoutPrefetch} href={paymentPageUrl} title={t("dashboard.settings.user_plan.current_plan_title")} className="bg-fill-primary !text-text-primary border border-transparent px-1" width="small" aria-disabled={true} testAttributePostfix={`button-plan-${pricePlan.title.toLowerCase()}-current`}><span className="truncate">{t("dashboard.settings.user_plan.current_plan_title")}</span></PrimaryButton> : isOneClickUpgradeAvailable ? <StripeWrapper><UpgradePlanConfirmationModal pricePlan={pricePlan} billingPeriod={billingPeriod} paymentPageUrl={paymentPageUrl} cost={costTitle + `/${t(periodLabel).toLowerCase()}`} paymentMethod={paymentMethod} isPlanUpgradeAvailable={isPlanUpgradeAvailable} /></StripeWrapper> : <div className="flex flex-col gap-2"><PrimaryButton as={LinkWithoutPrefetch} href={paymentPageUrl} title={t("dashboard.settings.user_plan.upgrade_plan_title")} className="bg-brand-primary hover:bg-background-secondary hover:text-brand-primary hover:border-brand-primary disabled:bg-text-secondary border-[1px] px-1 hover:border-solid" aria-disabled={!paymentPageUrl || !isPlanUpgradeAvailable} testAttributePostfix={`link-plan-${pricePlan.title.toLowerCase()}-upgrade`}><span className="truncate">{t("dashboard.settings.user_plan.upgrade_plan_title")}</span></PrimaryButton></div>;
    $[0] = active;
    $[1] = billingPeriod;
    $[2] = isOneClickUpgradeAvailable;
    $[3] = isPlanUpgradeAvailable;
    $[4] = paymentMethod;
    $[5] = pricePlan;
    $[6] = t;
    $[7] = user?.dashboardLocale;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[28] !== active || $[29] !== t || $[30] !== user?.accessRestricted) {
    t9 = active && user?.accessRestricted && <div className="text-danger text-center text-base font-normal">{t("dashboard.settings.user_plan.restricted")}</div>;
    $[28] = active;
    $[29] = t;
    $[30] = user?.accessRestricted;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== t3 || $[33] !== t4 || $[34] !== t5 || $[35] !== t6 || $[36] !== t9) {
    t10 = <div className={t3}>{t4}{t5}{t6}{t9}</div>;
    $[32] = t3;
    $[33] = t4;
    $[34] = t5;
    $[35] = t6;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== t10 || $[39] !== t7 || $[40] !== t8) {
    t11 = <div key={t7} className={t8}>{t10}</div>;
    $[38] = t10;
    $[39] = t7;
    $[40] = t8;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  return t11;
};
export default HeaderBlock;